import { createApiActions } from '../../../helpers/actions';

export const getCommands = createApiActions()(
  'commands/getCommands',
  'commands/getCommandsSuccess',
  'commands/getCommandsError',
  (siteId) => ({ siteId })
);

export const runCommand = createApiActions()(
  'commands/runCommand',
  'commands/runCommandSuccess',
  'commands/runCommandError',
  (siteId, command) => ({ siteId, command })
);
